export const MyEntriesPath = '/my-entries';
export const MyEntriesUrls = {
  page: `${MyEntriesPath}`,
  entry: `${MyEntriesPath}/:type`,
  experts: `${MyEntriesPath}/experts`,
  business: `${MyEntriesPath}/business`,
  events: `${MyEntriesPath}/events`,
};
